import { CheckboxProps } from '@mui/material/Checkbox'
import { FC, memo } from 'react'
import { StyledCheckbox, StyledFormControlLabel } from './checkboxV2.styles'

export type CheckboxV2Props = CheckboxProps & {
  label?: string
}

const CheckboxV2: FC<CheckboxV2Props> = ({ label, ...props }) => {
  return (
    <>
      <StyledFormControlLabel label={label} control={<StyledCheckbox {...props} />} />
    </>
  )
}

export default memo(CheckboxV2)
